

// components/popup/WitnessPopup.tsx
import React, { Dispatch, SetStateAction } from 'react';
import { PersonSearchPopup } from './PersonSearchPopup';
import { Person } from 'types';

interface WitnessPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  onSearchPerson: (e: React.FormEvent) => void;
  onPersonSelect: (personId: string) => void;
  onUserSubmit: (data: any, isEditMode: boolean) => void;
  formData: any;
  loading: boolean;
  error: string | null;
  searchFayda: string;
  setSearchFayda: (value: string) => void;
  searchPhone: string;
  setSearchPhone: (value: string) => void;
  searchedPersons: any[];
  selectedPerson: any;
  selectedPersonId: string;
  searchLoading: boolean;
  userFormLoading: boolean;
  isEditMode?: boolean;
  existingData?: any;
       setSelectedPerson?: Dispatch<SetStateAction<Person | null>>;
          setSelectedPersonId?: Dispatch<SetStateAction<string>>;
          setSearchedPersons?: Dispatch<SetStateAction<Person[]>>;
}

export const WitnessPopup: React.FC<WitnessPopupProps> = (props) => {
  return (
    <PersonSearchPopup
      {...props}
      title={props.isEditMode ? "Edit Witness" : "Add Witness"}
      description={props.isEditMode ? "Edit witness information" : "Add witness information"}
      isEditMode={props.isEditMode}
      existingData={props.existingData}
         setSearchedPersons={props.setSearchedPersons}
      setSelectedPerson={props.setSelectedPerson}
      setSelectedPersonId={props.setSelectedPersonId}
    >
      <div className="flex flex-col">
        <label className="referral-popup-label">Testimony Summary</label>
        <textarea
          className="referral-form-field h-24"
          onChange={props.onInputChange}
          name="testimony_summary"
          placeholder="Testimony Summary"
          value={props.formData.testimony_summary}
        />
      </div>
    </PersonSearchPopup>
  );
};